import * as angularCommon from "@angular/common";
import * as angularCommonHttp from "@angular/common/http";
// global glue variable for externals
if (window["ng"] == null) window["ng"] = <any>{};

// make sure to reuse existing common stuff
window["ng"].common = angularCommon;
window["ng"].common.http = angularCommonHttp;

export { angularCommon, angularCommonHttp };
